function getQueryVariable(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
    let r
    if (window.location.hash.includes('#')) {
        if (window.location.hash.includes('token')) {
            r = window.location.hash.split('?')[1].match(reg)
            if (r != null) return unescape(r[2])
        }
    } else {
        r = window.location.search.substr(1).match(reg)
    }
    if (r != null) return unescape(r[2])
}

var token = getQueryVariable('token') || ''
var language = getQueryVariable('language') || ''
var subjectType = getQueryVariable('subjectType') || ''
if (token) {
    store.commit('SET_USER_INFO', 'n')
    store.commit('SET_ISLOGIN', '1')
    store.commit('SET_TOKEN', decodeURIComponent(token))
    store.commit('SET_LANGUAGE', language || 'zh')
    store.commit('SET_LANGUAGE_OLD', language || 'zh')
    store.commit('SET_SUBJECTTYPE', subjectType)
}
// if (language) {
//   store.commit('SET_LANGUAGE', language || 'zh')
//   store.commit('SET_LANGUAGE_OLD', language || 'zh')
// }


import './utils/gobal'
import './utils/ranger_extend'
import '@/assets/scss/element.scss'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueClipboard from 'vue-clipboard2'
import VueKonva from 'vue-konva'
import md5 from 'js-md5' //密码 需要 md5加密
import { MessageBox } from 'element-ui'
import tools from './utils/tools'
import vueFilter from './utils/filter'
import config from './config/index'
import * as funcs from '@/utils/function'
import i18n, { en, zh } from '@/utils/i18n'
import business from '@/utils/business'
import './permission' //路由权限
import './utils/validateRules'
import 'swiper/css/swiper.css'
import './utils/TIM'

//默认头像
import person from './assets/images/person.png'
import actor from './assets/images/actor.png'
import exhLogo from './assets/images/exhLogo.png'
import product from './assets/images/product.png'
import product3 from './assets/images/product2.png'
import VueLazyload from 'vue-lazyload'
/**
 * 使 axios 支持 finally
 */
import promiseFinally from 'promise.prototype.finally'

import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
promiseFinally.shim()

Vue.use(VueAwesomeSwiper /* { default options with global component } */)


Vue.use(VueLazyload, {
  attempt: 1
})

Vue.use(VueKonva)
Vue.use(VueClipboard)

Vue.config.productionTip = false

Vue.prototype.$md5 = md5
Vue.prototype.$funcs = funcs

// 全局配置项
Vue.prototype.$config = config

Object.keys(tools).forEach(key => {
  Vue.prototype[key] = tools[key]
})

Object.keys(vueFilter).forEach(key => {
  Vue.filter(key, vueFilter[key])
})

Object.keys(business).forEach(key => {
  Vue.prototype[key] = business[key]
})

// 默认头像
Vue.prototype.defImage = function(type) {
  if (type == 'head') {
    return person
  } else if (type == 'actor') {
    return actor
  } else if (type == 'product') {
    return exhLogo
  } else if (type == 'product1') {
    return product3
  } else if (type == 'product2') {
    return product3
  } else if (type == 'product3') {
    return product3
  } else {
    return product
  }
}

Vue.prototype.minImageThree = function (list = [], type) {
  if (list.length < 1) {
    for (let i = list.length; i < 1; i++) {
      if (type == 'product2') {
        list.push(product3)
      } else if (type == 'product3') {
        list.push(product3)
      } else {
        list.push(product)
      }
    }
  }
  return list
}

// 生成UUID
Vue.prototype.uuid = (len = 16, radix = 16) => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  const uuid = []
  let i
  radix = radix || chars.length

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
    // rfc4122, version 4 form
    let r

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
      }
    }
  }

  return uuid.join('')
}

// window.PC = window.PC || {}
window.PC.setLang(zh, en)
window.PC.$config = config

if (funcs.browser.trident) {
  MessageBox.confirm('暂不支持IE,请使用其他浏览器', '提示', {
    showClose: false,
    showCancelButton: false,
    showConfirmButton: false,
    closeOnClickModal: false,
    type: 'warning'
  })
} else {
  window.PC.$RangersConfigInit(store.state)
  window.vm = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')

  window.PC.app = window.vm
}
